"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _browserImageCompression = _interopRequireDefault(require("browser-image-compression"));
var _react = _interopRequireDefault(require("react"));
var _lodash = _interopRequireDefault(require("lodash"));
var _config = require("../config");
var _core = require("@material-ui/core");
var _Translations = require("../Translations");
var _reactIntl = require("react-intl");
var _styles = require("@material-ui/core/styles");
var _helpers = require("../helpers");
var _MultiImageUploder = require("./MultiImageUploder");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var styles = function styles(theme) {
  return {
    container: {
      backgroundColor: '#e0e0e0',
      boxShadow: '0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12)',
      borderRadius: 4,
      display: 'block',
      height: 164,
      padding: 0,
      position: 'relative',
      textAlign: 'center',
      transition: 'background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,border 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
      '&:hover': {
        backgroundColor: '#d5d5d5',
        boxShadow: '0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12)',
        '& > .cameraIcon': {
          color: '#f1f1f1'
        },
        '& > .helperBanner': {
          backgroundColor: '#3e3c3c',
          boxShadow: '0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12)'
        }
      }
    },
    helperBanner: {
      color: '#fff6f6',
      backgroundColor: '#686262',
      paddingTop: 8,
      paddingBottom: 9,
      borderBottomRightRadius: 4,
      borderBottomLeftRadius: 4,
      transition: 'background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,border 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms'
    },
    cameraIcon: {
      color: '#d6d6d6',
      fontSize: '72px',
      height: 75,
      marginTop: 50,
      width: 75,
      zIndex: 0,
      transition: 'color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,border 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms'
    }
  };
};
var ImageUploader = /*#__PURE__*/function (_React$Component) {
  _inherits(ImageUploader, _React$Component);
  var _super = _createSuper(ImageUploader);
  function ImageUploader(props) {
    var _this;
    _classCallCheck(this, ImageUploader);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "handleChange", function (event) {
      var hasError = false;
      // Grab the selected file
      var file = event.target.files[0];
      // Here we do a validation on the file size
      // We add an error to the our form field if the requirement is not met
      if (_this.props.maxTotalSize) {
        if (file.size >= _this.props.maxTotalSize) {
          _this.props.form.setFieldError(_this.props.field.name, "".concat(_this.props.intl.formatMessage({
            id: "La taille des images doit être inférieure à",
            defaultMessage: "La taille des images doit être inférieure à"
          }), " ").concat(_this.props.maxTotalSize / 1000000, " MB"));
          _this.props.form.setFieldTouched(_this.props.field.name, true, false);
          hasError = true;
        }
      }
      if (!hasError) {
        if (_this.props.accept.indexOf(file.type) !== -1) {
          _this.setState({
            isProcessing: true
          });
          (0, _browserImageCompression.default)(file, _MultiImageUploder.COMPRESS_OPTIONS).then(function (blob) {
            var compressedFile = new File([blob], file.name, {
              type: file.type,
              lastModified: Date.now()
            });
            var imageUrl = URL.createObjectURL(compressedFile);
            _this.setState({
              file: compressedFile,
              image: imageUrl,
              isProcessing: false
            });
            _this.props.form.setFieldValue(_this.props.field.name, compressedFile);
            if (_this.props.onSelectImage) {
              _this.props.onSelectImage(imageUrl);
            }
          });
          // If the format is one that we're not accepting, we add an error to the form field
        } else {
          _this.props.setFieldError(_this.props.field.name, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
            id: "Format de fichier non pris en charge, ces champs acceptent uniquement les images.",
            defaultMessage: "Format de fichier non pris en charge, ces champs acceptent uniquement les images."
          }));
          _this.props.setFieldTouched(_this.props.field.name, true, false);
        }
        if (event.target && event.target.value) {
          event.target.value = '';
        }
      }
    });
    _defineProperty(_assertThisInitialized(_this), "handleMouseOver", function () {
      if (!!_this.state.image) {
        _this.setState({
          hovred: true
        });
      }
    });
    _defineProperty(_assertThisInitialized(_this), "handleMouseOut", function () {
      if (!!_this.state.image) {
        _this.setState({
          hovred: false
        });
      }
    });
    _defineProperty(_assertThisInitialized(_this), "handleClick", function () {
      _this.props.form.setFieldValue(_this.props.field.name, undefined);
      _this.setState({
        error: false,
        file: '',
        hovred: false,
        image: null,
        isProcessing: false
      });
    });
    _this.state = {
      error: false,
      file: '',
      hovred: false,
      image: null,
      isProcessing: false
    };
    return _this;
  }
  _createClass(ImageUploader, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      var value = this.props.field.value;
      if (value && !(value instanceof File)) {
        this.setState({
          image: (0, _helpers.joinPaths)(_config.BASE_URL, value)
        });
      } else if (value instanceof File) {
        this.setState({
          image: this.props.form.values[this.props.image_name]
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        classes = _this$props.classes,
        field = _this$props.field,
        form = _this$props.form,
        height = _this$props.height,
        width = _this$props.width,
        style = _this$props.style;
      var isProcessing = this.state.isProcessing;
      var meta = form.getFieldMeta(field.name);
      var hasError = Boolean(meta.error || !_lodash.default.isEmpty(meta.error));
      return /*#__PURE__*/_react.default.createElement("div", {
        onMouseOver: this.handleMouseOver,
        onMouseLeave: this.handleMouseOut,
        className: classes.container,
        style: _objectSpread({
          height: height,
          width: width,
          border: hasError ? '2px solid #f44336' : '',
          backgroundColor: hasError ? '#f44336' : ''
        }, style)
      }, !this.state.image && /*#__PURE__*/_react.default.createElement("input", {
        onChange: this.handleChange,
        type: "file",
        name: field.name || "image",
        accept: this.props.accept,
        style: {
          cursor: 'pointer',
          display: 'block',
          height: 172,
          opacity: 0,
          padding: 1,
          position: 'absolute',
          width: 172
        },
        capture: "camera"
        // value={_.isString(field.value) ? field.value : undefined}
      }), !this.state.image && /*#__PURE__*/_react.default.createElement(_core.Icon, {
        className: "".concat(classes.cameraIcon, " cameraIcon")
      }, "photo_camera"), isProcessing && /*#__PURE__*/_react.default.createElement(_core.CircularProgress, {
        thickness: 7,
        size: 33,
        style: {
          position: 'absolute',
          top: '42%',
          left: '40%'
        }
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "".concat(classes.helperBanner, " helperBanner")
      }, /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
        id: "Ajouter un logo",
        defaultMessage: "Ajouter un logo"
      }))), !!this.state.image && /*#__PURE__*/_react.default.createElement("img", {
        src: this.state.image,
        alt: "",
        style: {
          borderRadius: 4,
          height: '100%',
          left: 0,
          position: 'absolute',
          top: 0,
          width: '100%'
        }
      }), this.state.image && /*#__PURE__*/_react.default.createElement("div", {
        style: {
          background: 'rgba(0, 0, 0, 0.5)',
          borderTopLeftRadius: 4,
          borderTopRightRadius: 4,
          color: '#fff',
          display: 'flex',
          fontSize: '14px',
          height: '25%',
          left: 0,
          position: 'absolute',
          right: 0,
          top: 0,
          width: '100%'
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        style: {
          color: '#fff',
          flexGrow: 1,
          marginLeft: '70%',
          overflow: 'hidden'
        }
      }, /*#__PURE__*/_react.default.createElement(_core.IconButton, {
        onClick: this.handleClick,
        style: {
          color: 'rgba(255, 255, 255, 0.54)'
        }
      }, /*#__PURE__*/_react.default.createElement(_core.Icon, null, "clear")))));
    }
  }]);
  return ImageUploader;
}(_react.default.Component);
_defineProperty(ImageUploader, "defaultProps", {
  height: 172,
  width: 172
});
ImageUploader.defaultProps = {
  accept: "image/bmp,image/gif,image/jpeg,image/png,image/x-ms-bmp",
  height: 164,
  width: 164
};
var _default = (0, _reactIntl.injectIntl)((0, _styles.withStyles)(styles)(ImageUploader));
exports.default = _default;